import React from 'react';
import { TypographyMuted } from '@/Components/shadcn';
import { siteUrls } from '@/AppSettings';
import UIStrings from '@/Utils/UIStrings';

function ContactSupportSection(): React.JSX.Element {
    return (
        <div className="flex flex-col items-start gap-4">
            <TypographyMuted>{UIStrings.ContactSupportSection}</TypographyMuted>
            <a
                href={siteUrls.contactSupportUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary text-sm font-medium no-underline hover:underline"
            >
                {UIStrings.ContactSupport}
            </a>
        </div>
    );
}

export default ContactSupportSection;
